// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301834/js/" + chunkId + "." + {"44":"b3372308","225":"bd7310ef","481":"69a5090a","486":"c081c919","770":"deed9b7e"}[chunkId] + ".0.5384925754524175.chunk.js";
};